var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.465 14.624.74-4.703h-4.563V6.864c0-1.286.637-2.543 2.674-2.543h2.105V.316A25.527 25.527 0 0 0 16.716 0c-3.756 0-6.209 2.256-6.209 6.335V9.92H6.345v4.703h4.163V26h5.135V14.624h3.823Z",
    fill: "var(--a, #000)"
  })));
};

export default SvgFacebook;